import { render } from "./Basic.vue?vue&type=template&id=1835dcdd&scoped=true"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"

import "./Basic.vue?vue&type=style&index=0&id=1835dcdd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1835dcdd"

export default script